// User Login
export const LOGIN = '@@user/LOGIN';
export const LOGIN_FULFILLED = '@@user/LOGIN_FULFILLED';
export const LOGIN_CANCELLED = '@@user/LOGIN_CANCELLED';
export const LOGIN_REJECTED = '@@user/LOGIN_REJECTED';

// Check Public Registration
export const CHECK_PUBLIC_REGISTRATION = '@@user/CHECK_PUBLIC_REGISTRATION';
export const CHECK_PUBLIC_REGISTRATION_FULFILLED = '@@user/CHECK_PUBLIC_REGISTRATION_FULFILLED';
export const CHECK_PUBLIC_REGISTRATION_CANCELLED = '@@user/CHECK_PUBLIC_REGISTRATION_CANCELLED';
export const CHECK_PUBLIC_REGISTRATION_REJECTED = '@@user/CHECK_PUBLIC_REGISTRATION_REJECTED';

// User Logout
export const LOGOUT = '@@user/LOGOUT';

// Prevent Login Loop
export const PREVENT_LOGIN_LOOP = '@@user/PREVENT_LOGIN_LOOP';

// successful verified mobile no.
export const GET_VERIFIED_MOBILE = '@@user/GET_VERIFIED_MOBILE';
export const CLEAN_VERIFIED_MOBILE = '@@user/CLEAN_VERIFIED_MOBILE';